import { images } from "../assets/img";

export const servicesItems = {
  uk: {
    services: [
      {
        img: images.icon2[1],
        title: "Self-Employed UTR Registration",
        shortText:
          "A Unique Taxpayer Reference (UTR) is a 10-digit code that uniquely identifies you or your business.",
        fullText:
          "It is highly confidential and essential if you earn self-employed income, income from rental property, or work under the Construction Industry Scheme (CIS). We handle the entire UTR registration process with HMRC on your behalf, ensuring your details are accurate so you can trade legally and start filing taxes with confidence.",
        id: "self_employed",
      },
      {
        img: images.icon2[2],
        title: "Self-Assessment Tax Return",
        shortText:
          "If you are self-employed, a sole trader, or a company director, HMRC requires you to complete a Self-Assessment tax return.",
        fullText:
          "Failing to submit it on time can result in heavy penalties, especially during challenging economic times. We take care of your Self-Assessment from start to finish, ensuring it’s accurate, submitted on time, and includes all allowable expenses—so you can have peace of mind while avoiding costly mistakes.",
        id: "satself_assessment",
      },
      {
        img: images.icon2[3],
        title: "Personal Tax",
        shortText:
          "When you have income from multiple sources or operate as a sole trader, HMRC requires you to register for Self-Assessment and pay tax accordingly.",
        fullText:
          "Our expertise combines compliance and advisory services, helping you navigate your personal tax obligations, identify tax-saving opportunities, and ensure that all filings are accurate and timely.",
        id: "personal_tax",
      },
      {
        img: images.icon2[3],
        title: "HMRC Investigation Support",
        shortText:
          "If you’re facing an HMRC enquiry, expert guidance is crucial.",
        fullText:
          "For contractors working through limited companies and outside IR35, life can be simpler, but HMRC rules still require that claimed expenses are wholly and exclusively for business purposes. Our specialist team provides full support and representation, handling all communications, preparing documentation, and working to achieve the best possible outcome while protecting your interests.",
        id: "hmrc",
      },
      {
        img: images.icon2[4],
        title: "Making Tax Digital (MTD)",
        shortText:
          "Stay compliant with HMRC’s digital requirements without the headache.",
        fullText:
          "We set up MTD-compliant bookkeeping software, integrate it with your accounting processes, and manage regular submissions. This ensures your records are accurate, up to date, and fully compliant, giving you control and visibility over your finances while avoiding penalties.",
        id: "mtd",
      },
      {
        img: images.icon2[5],
        title: "VAT Registration & Returns",
        shortText:
          "Whether you are new to VAT or already registered, we make compliance straightforward.",
        fullText:
          "From registration to quarterly VAT returns, we handle the process end-to-end, ensuring all deadlines are met and your filings are accurate. Our service helps you avoid costly mistakes while keeping your business financially healthy.",
        id: "vat",
      },
      {
        img: images.icon2[6],
        title: "CIS (Construction Industry Scheme)",
        shortText:
          "For contractors and subcontractors, CIS compliance is essential.",
        fullText:
          "We manage deductions, monthly and annual returns, and statutory reporting. Our services ensure you meet HMRC requirements, reduce administrative burden, and maintain smooth cash flow—so you can focus on completing projects without worrying about compliance issues.",
        id: "cis",
      },
    ],
    limitedCompany: [
      {
        img: images.icon2[1],
        title: "Company Formation & Registration",
        shortText:
          "Starting a new company can be complex, but we make it simple.",
        fullText:
          "We handle the entire registration process with Companies House and HMRC, including setting up Corporation Tax, PAYE, and VAT registration if required. Our service ensures your company is fully compliant from day one, helping you avoid costly mistakes and giving you confidence to focus on growing your business.",
        id: "company_formation",
      },
      {
        img: images.icon2[2],
        title: "Bookkeeping",
        shortText:
          "Accurate bookkeeping is the backbone of any successful business..",
        fullText:
          "We manage your day-to-day financial records using MTD-compliant software, tracking income, expenses, and transactions efficiently. This ensures your accounts are always up to date, making tax submissions, management decisions, and financial planning straightforward and stress-free.",
        id: "company_bookkeeping",
      },
      {
        img: images.icon2[3],
        title: "Annual Statutory Accounts",
        shortText:
          "We prepare and file your annual statutory accounts in full compliance with Companies House and HMRC requirements.",
        fullText:
          "Our experienced accountants ensure your financial statements are accurate and complete, giving stakeholders confidence and helping your business maintain a strong compliance record.",
        id: "company_accounts",
      },
      {
        img: images.icon2[4],
        title: "Corporation Tax Returns (CT600)",
        shortText:
          "Navigating Corporation Tax can be challenging, but we simplify the process.",
        fullText:
          "We handle your CT600 submissions from start to finish, identifying allowable expenses, applying relevant reliefs, and ensuring you pay only what is legally due. With careful planning, we help you stay compliant while maximising tax efficiency.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "Payroll Services",
        shortText:
          "Payroll doesn’t have to be stressful. We manage everything from PAYE registration and weekly or monthly payroll runs to accurate tax and National Insurance calculations.",
        fullText:
          "We also prepare payslips, P45s, and P60s, and ensure all year-end filings are completed correctly and on time, so you can keep employees happy and stay fully compliant.",
        id: "payroll",
      },
      {
        img: images.icon2[6],
        title: "CIS Returns",
        shortText:
          "For construction contractors, timely and accurate CIS returns are essential.",
        fullText:
          "We manage all aspects of CIS compliance, including deductions, statements, and submissions to HMRC. This allows you to focus on delivering your projects while we ensure your obligations are met without errors or delays.",
        id: "company_cis",
      },
      {
        img: images.icon2[7],
        title: "Management Accounts & Reporting",
        shortText:
          "Stay on top of your business performance with regular management accounts.",
        fullText:
          "We provide clear, actionable reports that help you monitor profitability, control cash flow, and make informed decisions throughout the year, empowering you to manage your business proactively rather than reactively.",
        id: "manage_accounts",
      },
      {
        img: images.icon2[8],
        title: "Business Forecasting & Budgeting",
        shortText:
          "Planning for growth requires accurate forecasting and budgeting.",
        fullText:
          "We help you create detailed financial forecasts and budgets, enabling you to manage cash flow effectively, anticipate future challenges, and make strategic decisions to support sustainable business growth.",
        id: "business_forecast",
      },
      {
        img: images.icon2[9],
        title: "Cloud Accounting Setup & Training",
        shortText:
          "We can set up cloud-based accounting software such as Xero, QuickBooks, or Sage and provide full training for you and your team.",
        fullText:
          "Cloud accounting allows real-time access to your financial data, simplifies bookkeeping, and makes reporting and compliance easier than ever.",
        id: "cloud_accouunting",
      },
      {
        img: images.icon2[10],
        title: "HMRC Investigations & Enquiries Support",
        shortText:
          "Facing an HMRC enquiry or audit can be intimidating. Our expert team represents you, manages all correspondence, and ensures the process is handled professionally.",
        fullText:
          "We protect your interests, help clarify any issues, and work to achieve the best possible outcome while reducing stress and disruption to your business.",
        id: "hmrc_investigations",
      },
    ],
    pertnership: [
      {
        img: images.icon2[1],
        title: "Register with HMRC",
        shortText:
          "Setting up a partnership requires precise registration with HMRC to ensure your business starts off compliant and well-structured. We manage the entire registration process on your behalf, ensuring all legal and tax obligations are properly completed. This includes registering the partnership for Self-Assessment and making sure each partner’s details are recorded correctly",
        fullText:
          "By handling the complexities for you, we eliminate the risk of mistakes that could cause delays or future compliance issues. With our support, your partnership begins on a strong legal and financial foundation, allowing you to focus on building and growing the business with confidence.",
        id: "register_with_hmrc",
      },
      {
        img: images.icon2[2],
        title: "Taxation",
        shortText:
          "Partnership taxation involves both the partnership tax return and individual Self-Assessment tax returns for each partner. We take care of the complete process, ensuring every return is accurate, compliant, and submitted on time.",
        fullText:
          "Our team reviews your financial information in detail, applies relevant allowances, and ensures profits are allocated correctly between partners. This approach protects your partnership from penalties while maximising tax efficiency for both the business and the individuals involved. You can rely on us to keep your tax obligations organised, clear, and professionally managed.",
        id: "taxation",
      },
      {
        img: images.icon2[3],
        title: "Cloud Accounting Setup & Training",
        shortText:
          "We provide complete setup of cloud-based accounting systems such as Xero, QuickBooks, or FreeAgent, ensuring your partnership’s financial records are organised and easy to manage. Our team configures the software to suit your business needs, helping streamline day-to-day bookkeeping and reporting. ",
        fullText:
          "We also offer comprehensive training for partners and staff, giving them the confidence to use the system effectively. With clear guidance and ongoing support, your partnership can benefit from real-time financial insights, improved efficiency, and fully compliant digital record-keeping.",
        id: "cloud_accounting",
      },
      {
        img: images.icon2[4],
        title: "Corporation Tax Returns (CT600)",
        shortText:
          "Navigating Corporation Tax can be challenging, but we simplify the process.",
        fullText:
          "We handle your CT600 submissions from start to finish, identifying allowable expenses, applying relevant reliefs, and ensuring you pay only what is legally due. With careful planning, we help you stay compliant while maximising tax efficiency.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "HMRC Investigations & Enquiries Support",
        shortText:
          "If your partnership is selected for an HMRC enquiry, we provide full professional support from start to finish. Our team manages all communication with HMRC on your behalf, ensuring accurate information is provided promptly.",
        fullText:
          "We guide you through documentation requirements, clarify the scope of the enquiry, and work to resolve matters fairly and efficiently. With our expertise, you can minimise disruption to your business, reduce stress, and ensure the best possible outcome. Our aim is to protect your partnership while maintaining full compliance with HMRC regulations.",
        id: "hmrc_investigations",
      },
    ],
  },
  ro: {
    services: [
      {
        img: images.icon2[1],
        title:
          "Înregistrarea UTR pentru persoană fizică autorizată (Self-Employed)",
        shortText:
          "Un cod UTR (Unique Taxpayer Reference) este un cod de 10 cifre care identifică în mod unic persoana ta sau afacerea ta. Este extrem de confidențial și esențial dacă ești persoană fizică autorizată, ai venituri din proprietăți închiriate sau lucrezi în cadrul Construction Industry Scheme (CIS).",
        fullText:
          "Noi gestionăm întregul proces de înregistrare UTR cu HMRC în numele tău, asigurându-ne că detaliile tale sunt corecte, astfel încât să poți opera legal.",
        id: "self_employed",
      },
      {
        img: images.icon2[2],
        title: "Declarația fiscală Self-Assessment",
        shortText:
          "Dacă ești persoană fizică autorizată, comerciant individual sau director de companie, HMRC solicită completarea unei declarații fiscale Self-Assessment. Neprezentarea declarației la timp poate atrage penalități de până la £1.600 pe an.",
        fullText:
          "Noi ne ocupăm de întocmirea corectă și depunerea la timp a declarației fiscale (Self Assessment), astfel încât să evitați greșelile costisitoare și stresul inutil.",
        id: "satself_assessment",
      },
      {
        img: images.icon2[3],
        title: "Impozitul pe venit personal",
        shortText:
          "Dacă ai venituri din multiple surse sau operezi ca self employed, sunteți obligat să vă înregistrați în Self Assessment, să vă declarați veniturile anuale și să vă plătiți impozitele pe venit.",
        fullText:
          "Expertiza noastră combina servicii de conformitate și consultanță, ajutându-te sa navighezi obligațiile fiscale personale, să indentifici oportunități legale de a economisi bani și să te asiguri că declarațiile fiscale (Tax Returns) sunt corecte și depuse la timp.",
        id: "personal_tax",
      },
      {
        img: images.icon2[3],
        title: "Asistență în caz de investigații HMRC",
        shortText:
          "În cazul unei investigații HMRC, experiența unui expert poate face diferența. Regulile sunt stricte și fiecare cheltuială trebuie justificată.",
        fullText:
          "Echipa noastră de experți se ocupă de tot: pregătirea documentelor, gestionarea corespondenței și reprezentarea ta, astfel încât să fii protejat și să obții cele mai bune rezultate posibile. Liniștea ta și siguranța afacerii tale sunt prioritatea noastră.",
        id: "hmrc",
      },
      {
        img: images.icon2[4],
        title: "Making Tax Digital (MTD)",
        shortText:
          "Conform cerințelor HMRC, persoanele self-employed, cele cu venituri din proprietăți sau înregistrate la TVA trebuie să păstreze registrele în format digital.",
        fullText:
          "Toate tranzacțiile bancare aferente activității trebuie conectate la un software contabil specializat, compatibil cu cerințele HMRC, iar rapoartele fiscale trebuie transmise electronic. Noi vă oferim suport în alegerea programului contabil potrivit pentru afacerea dvs., gestionăm transmiterea declarațiilor către HMRC și vă asigurăm transparență, control și vizibilitate completă asupra performanței afacerii.",
        id: "mtd",
      },
      {
        img: images.icon2[5],
        title: "Înregistrare și Declarații de TVA (VAT)",
        shortText:
          "Indiferent dacă ești deja înregistrat la TVA sau abia pornești acest proces, noi ne ocupăm de tot – de la înregistrarea inițială până la depunerea declarațiilor trimestriale.",
        fullText:
          "Echipa noastră se asigură că toate rapoartele sunt corecte și depuse la timp, respectând termenele legale, astfel încât să eviți penalitățile și erorile costisitoare. Serviciul nostru îți oferă siguranță financiară și liniște, astfel încât să te poți concentra pe ceea ce contează cu adevărat: dezvoltarea afacerii tale.",
        id: "vat",
      },
      {
        img: images.icon2[6],
        title: "CIS (Construction Industry Scheme)",
        shortText:
          "Pentru antreprenori și subcontractori, conformitatea cu CIS este esențială. Gestionăm deducerile, declarațiile lunare și anuale, precum și raportarea statutară.",
        fullText:
          "Serviciile noastre asigură că îndepliniți cerințele HMRC, reduc povara administrativă și mențin un flux de numerar lin, astfel încât să vă puteți concentra pe finalizarea proiectelor fără a vă face griji cu privire la problemele de conformitate.",
        id: "cis",
      },
    ],
    limitedCompany: [
      {
        img: images.icon2[1],
        title: "Înființarea și înregistrarea companiei",
        shortText:
          "Începerea unei noi afaceri poate fi complicată, dar noi o facem simplă. Gestionăm întregul proces de înregistrare la Companies House și HMRC, inclusiv configurarea impozitului pe profit, PAYE și, dacă este necesar, înregistrarea TVA.",
        fullText:
          "Serviciul nostru asigură că firma dumneavoastră este complet conformă de la primul moment, ajutându-vă să evitați greșelile costisitoare și oferindu-vă încrederea de a vă concentra pe dezvoltarea afacerii.",
        id: "company_formation",
      },
      {
        img: images.icon2[2],
        title: "Evidență Contabilă (Bookkeeping)",
        shortText:
          "O contabilitate precisă este fundația oricărei afaceri de succes. Gestionăm evidențele financiare zilnice folosind software compatibil MTD, urmărind venituri, cheltuieli și tranzacții eficient.",
        fullText:
          "Astfel, conturile dumneavoastră sunt mereu actualizate, facilitând depunerile fiscale, luarea deciziilor și planificarea financiară fără stres.",
        id: "company_bookkeeping",
      },
      {
        img: images.icon2[3],
        title: "Raportări Financiare Anuale",
        shortText:
          "Noi asigurăm pregătirea și depunerea rapoartelor financiare anuale în strictă conformitate cu cerințele Companies House și HMRC",
        fullText:
          "Echipa noastră se asigură că rapoartele financiare reflectă cu acuratețe performanța afacerii, oferind încredere părților interesate, investitorilor și creditorilor. Gestionăm întregul proces de raportare, astfel încât afacerea dumneavoastră să reducă riscurile de penalități și să păstreze stabilitatea financiară.",
        id: "company_accounts",
      },
      {
        img: images.icon2[4],
        title: "Declarații privind impozitul pe profit (CT600)",
        shortText:
          "Gestionarea impozitului pe profit poate fi provocatoare, dar noi simplificăm procesul. Ne ocupăm de depunerea declarațiilor CT600 de la început până la sfârșit",
        fullText:
          ", identificând cheltuielile deductibile, aplicând reducerile relevante și asigurându-ne că plătiți doar ceea ce este legal datorat. Cu o planificare atentă, vă ajutăm să rămâneți conform și să maximizați eficiența fiscală.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "Servicii de Salarizare",
        shortText:
          "Salarizarea nu trebuie să fie o sursă de stres. Gestionăm întregul proces, de la înregistrarea PAYE și rularea salarială săptămânală sau lunară, până la calcule precise ale impozitelor și Contribuțiilor de Asigurări Naționale (National Insurance).",
        fullText:
          "Pregătim, de asemenea, fluturașii de salariu (payslips), formularele P45 și P60 și ne asigurăm că toate depunerile de sfârșit de an sunt finalizate corect și la timp, astfel încât să vă mențineți angajații mulțumiți și să fiți pe deplin conformi.",
        id: "payroll",
      },
      {
        img: images.icon2[6],
        title: "Declarații CIS",
        shortText:
          "Pentru contractori și subcontractori, conformitatea cu CIS este esențială. Gestionăm integral obligațiile tale legate de schema CIS, de la depunerea declarațiilor lunare și anuale până la raportarea statutară.",
        fullText:
          "Cu expertiza noastră, evitați erorile costisitoare și întârzierile, menținând transparență, conformitate și control complet asupra situației fiscale, astfel încât să vă puteți concentra pe dezvoltarea proiectelor și creșterea afacerii.",
        id: "company_cis",
      },
      {
        img: images.icon2[7],
        title: "Raportare și contabilitate managerială",
        shortText:
          "Fiți la curent cu performanța afacerii dumneavoastră prin conturi de management regulate.",
        fullText:
          "Oferim rapoarte clare și practice care vă ajută să monitorizați profitabilitatea, să controlați fluxul de numerar și să luați decizii informate pe tot parcursul anului, dându-vă puterea de a vă gestiona afacerea proactiv, nu reactiv.",
        id: "manage_accounts",
      },
      {
        img: images.icon2[8],
        title: "Planificare financiară și bugetare",
        shortText:
          "Planificarea pentru creștere necesită previziuni și bugete precise. Vă ajutăm să creați previziuni și bugete financiare detaliate",
        fullText:
          ", permițându-vă să gestionați eficient fluxul de numerar, să anticipați provocările viitoare și să luați decizii strategice pentru a susține o creștere durabilă a afacerii.",
        id: "business_forecast",
      },
      {
        img: images.icon2[9],
        title: "Configurare și Instruire Contabilitate Cloud",
        shortText:
          "Putem configura software de contabilitate bazat pe cloud, cum ar fi Xero, QuickBooks sau Sage, și oferim instruire completă pentru dumneavoastră și echipa dumneavoastră.",
        fullText:
          "Contabilitatea în cloud permite acces în timp real la datele financiare, simplifică evidența contabilă și face ca raportarea și conformitatea să fie mai ușoare ca niciodată.",
        id: "cloud_accouunting",
      },
      {
        img: images.icon2[10],
        title: "Suport pentru Investigațiile HMRC",
        shortText:
          "Confruntarea cu o anchetă sau un audit din partea HMRC poate fi intimidantă. Echipa noastră de experți vă reprezintă, gestionează toată corespondența și se asigură că procesul este tratat profesional.",
        fullText:
          "Vă protejăm interesele, ajutăm la clarificarea oricăror probleme și lucrăm pentru a obține cel mai bun rezultat posibil, reducând în același timp stresul și perturbările pentru afacerea dumneavoastră.",
        id: "hmrc_investigations",
      },
    ],
    pertnership: [
      {
        img: images.icon2[1],
        title: "Înregistrare la HMRC",
        shortText:
          "Înființarea unui parteneriat necesită o înregistrare precisă la HMRC pentru a vă asigura că afacerea dumneavoastră începe conformă și bine structurată.",
        fullText:
          "Ne ocupăm de întregul proces de înregistrare în numele dumneavoastră, asigurându-ne că toate obligațiile legale și fiscale sunt îndeplinite corespunzător. Aceasta include înregistrarea parteneriatului pentru Self-Assessment și înregistrarea corectă a detaliilor fiecărui partener. Gestionând complexitățile în locul dumneavoastră, eliminăm riscul de erori care ar putea cauza întârzieri sau probleme viitoare de conformitate. Cu sprijinul nostru, parteneriatul dumneavoastră pornește pe o bază legală și financiară solidă, permițându-vă să vă concentrați pe dezvoltarea afacerii cu încredere.",
        id: "register_with_hmrc",
      },
      {
        img: images.icon2[2],
        title: "Fiscalitate (Taxation)",
        shortText:
          "Impozitarea unui parteneriat implică atât declarația fiscală a parteneriatului, cât și declarațiile individuale de Self-Assessment pentru fiecare partener.",
        fullText:
          "Ne ocupăm de întregul proces, asigurându-ne că fiecare declarație este precisă, conformă și depusă la timp. Echipa noastră analizează în detaliu informațiile dumneavoastră financiare, aplică scutirile relevante și se asigură că profiturile sunt alocate corect între parteneri. Această abordare vă protejează parteneriatul de penalități, maximizând în același timp eficiența fiscală atât pentru afacere, cât și pentru persoanele fizice implicate. Vă puteți baza pe noi pentru a vă menține obligațiile fiscale organizate, clare și gestionate profesional.",
        id: "taxation",
      },
      {
        img: images.icon2[3],
        title: "Configurare și Instruire Contabilitate Cloud",
        shortText:
          "Oferim configurarea completă a sistemelor de contabilitate bazate pe cloud, precum Xero, QuickBooks sau FreeAgent, asigurându-ne că înregistrările financiare ale parteneriatului dumneavoastră sunt organizate și ușor de gestionat.",
        fullText:
          "Echipa noastră configurează software-ul pentru a se potrivi nevoilor afacerii dumneavoastră, ajutând la simplificarea evidenței contabile și a raportării zilnice. De asemenea, oferim instruire cuprinzătoare pentru parteneri și personal, oferindu-le încrederea de a utiliza sistemul eficient. Cu îndrumare clară și sprijin continuu, parteneriatul dumneavoastră poate beneficia de perspective financiare în timp real, eficiență îmbunătățită și o evidență digitală pe deplin conformă.",
        id: "cloud_accounting",
      },
      {
        img: images.icon2[4],
        title: "Declarații privind impozitul pe profit (CT600)",
        shortText:
          "Navigarea prin Impozitul pe Profit (Corporation Tax) poate fi dificilă, dar noi simplificăm procesul.",
        fullText:
          "Ne ocupăm de depunerile dumneavoastră de formulare CT600 de la început până la sfârșit, identificând cheltuielile deductibile, aplicând scutirile relevante și asigurându-ne că plătiți doar ceea ce este datorat legal. Printr-o planificare atentă, vă ajutăm să rămâneți conformi, maximizând în același timp eficiența fiscală.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "Suport pentru Investigațiile și Solicitările HMRC",
        shortText:
          "Dacă parteneriatul dumneavoastră este selectat pentru o solicitare (enquiry) din partea HMRC, oferim suport profesional complet de la început până la sfârșit.",
        fullText:
          "Echipa noastră gestionează toată comunicarea cu HMRC în numele dumneavoastră, asigurându-se că informațiile corecte sunt furnizate prompt. Vă ghidăm prin cerințele de documentație, clarificăm scopul solicitării și lucrăm pentru a soluționa problemele în mod corect și eficient. Datorită expertizei noastre, puteți minimiza perturbarea afacerii, reduce stresul și asigura cel mai bun rezultat posibil. Scopul nostru este de a vă proteja parteneriatul, menținând în același timp conformitatea deplină cu reglementările HMRC.",
        id: "hmrc_investigations",
      },
    ],
  },
  ru: {
    services: [
      {
        img: images.icon2[1],
        title:
          "Регистрация UTR для индивидуального предпринимателя (Self-Employed)",
        shortText:
          "Номер UTR (Unique Taxpayer Reference) — это уникальный 10-значный код, который идентифицирует вас или ваш бизнес.",
        fullText:
          "Это строго конфиденциальный и важный номер, если вы являетесь самозанятым, получаете доход от аренды недвижимости или работаете в рамках строительной индустрии (CIS). Мы полностью берём на себя процесс регистрации UTR в HMRC от вашего имени, гарантируя корректность всех данных, чтобы вы могли законно вести деятельность.",
        id: "self_employed",
      },
      {
        img: images.icon2[2],
        title: "Налоговая декларация Self-Assessment",
        shortText:
          "Если вы являетесь индивидуальным предпринимателем или директором компании, HMRC требует заполнения налоговой декларации Self-Assessment.",
        fullText:
          "Несвоевременная подача может повлечь за собой штрафы до £1600 в год. Мы занимаемся правильным составлением и своевременной подачей вашей декларации Self-Assessment, помогая избежать дорогостоящих ошибок и лишнего стресса.",
        id: "satself_assessment",
      },
      {
        img: images.icon2[3],
        title: "Подоходный налог (Personal Income Tax)",
        shortText:
          "Если вы получаете доход из нескольких источников или работаете как self-employed",
        fullText:
          ", вы обязаны зарегистрироваться в системе Self-Assessment, ежегодно декларировать свои доходы и уплачивать налоги. Наш опыт сочетает в себе услуги по соблюдению нормативных требований и консультирование, помогая вам ориентироваться в налоговых обязательствах, находить законные возможности для экономии и гарантировать правильность и своевременность подачи налоговых деклараций (Tax Returns).",
        id: "personal_tax",
      },
      {
        img: images.icon2[3],
        title: "Помощь при проверках HMRC",
        shortText:
          "В случае налоговой проверки со стороны HMRC опыт эксперта может иметь решающее значение.",
        fullText:
          "Правила строгие, и каждый расход должен быть обоснован. Наша команда экспертов берет всё на себя: подготовку документов, ведение переписки и представление ваших интересов, чтобы обеспечить вашу защиту и достичь наилучших результатов. Ваше спокойствие и безопасность бизнеса — наш приоритет.",
        id: "hmrc",
      },
      {
        img: images.icon2[4],
        title: "Making Tax Digital (MTD)",
        shortText:
          "Согласно требованиям HMRC, индивидуальным предпринимателем с доходом от аренды недвижимости или зарегистрированные как плательщики НДС (VAT) должны вести учет в цифровом формате.",
        fullText:
          "Все банковские операции, связанные с бизнесом, должны проводиться через специализированное бухгалтерское ПО, совместимое с требованиями HMRC, а налоговые отчеты должны подаваться в электронном виде. Мы поможем вам выбрать подходящую программу, возьмем на себя передачу данных в налоговую и обеспечим полную прозрачность и контроль над показателями вашего бизнеса.",
        id: "mtd",
      },
      {
        img: images.icon2[5],
        title: "Регистрация и декларации по НДС (VAT)",
        shortText:
          "Независимо от того, обязаны ли вы уже регистрироваться как плательщик НДС",
        fullText:
          "или только планируете этот шаг, мы возьмем на себя весь процесс — от первичной регистрации до подачи квартальных деклараций. Наша команда проследит за правильностью всех отчетов и соблюдением законных сроков, чтобы вы могли избежать штрафов и дорогостоящих ошибок. Наша услуга обеспечит вам финансовую безопасность и спокойствие, позволяя сосредоточиться на главном — развитии вашего дела.",
        id: "vat",
      },
      {
        img: images.icon2[6],
        title: "CIS (Строительная индустрия)",
        shortText:
          "Для предпринимателей и субподровчиков соблюдение правил CIS имеет критическое значение.",
        fullText:
          "Мы управляем вашими вычетами, подаем ежемесячные и годовые декларации, а также занимаемся уставной отчетностью. Наши услуги гарантируют полное соответствие требованиям HMRC, снижают административную нагрузку и поддерживают стабильный денежный поток, чтобы вы могли завершать свои проекты.",
        id: "cis",
      },
    ],
    limitedCompany: [
      {
        img: images.icon2[1],
        title: "Создание и регистрация компании",
        shortText:
          "Начало новой компании может быть сложным, но мы делаем этот процесс простым.",
        fullText:
          "Мы берем на себя весь процесс регистрации в Companies House и HMRC, включая создание Corporation Tax, PAYE и, при необходимости, регистрацию по НДС. Наш сервис гарантирует, что ваша компания полностью соответствует требованиям с первого дня, помогая избежать дорогостоящих ошибок и давая вам уверенность для сосредоточения на развитии бизнеса.",
        id: "company_formation",
      },
      {
        img: images.icon2[2],
        title: "Бухгалтерский учет",
        shortText:
          "Точный бухгалтерский учет — основа любого успешного бизнеса.",
        fullText:
          "Мы ведем ежедневный финансовый учет с использованием программного обеспечения, соответствующего требованиям MTD, отслеживая доходы, расходы и транзакции эффективно. Это гарантирует актуальность ваших счетов, упрощает подачу налоговой отчетности, управленческие решения и финансовое планирование.",
        id: "company_bookkeeping",
      },
      {
        img: images.icon2[3],
        title: "Годовая финансовая отчетность",
        shortText:
          "Мы готовим и подаем вашу годовую финансовую отчетность в полном соответствии с требованиями Companies House и HMRC.",
        fullText:
          "Наши опытные бухгалтеры обеспечивают точность и полноту финансовых отчетов, что укрепляет доверие заинтересованных сторон и помогает вашему бизнесу поддерживать безупречную репутацию в вопросах соблюдения законодательства.",
        id: "company_accounts",
      },
      {
        img: images.icon2[4],
        title: "Декларация по налогу на прибыль (CT600)",
        shortText:
          "Ориентироваться в корпоративном налогообложении может быть сложно, но мы упрощаем этот процесс.",
        fullText:
          "Мы берем на себя подачу формы CT600 от начала до конца, выявляя допустимые расходы, применяя соответствующие льготы и гарантируя, что вы платите только то, что положено по закону. Благодаря тщательному планированию мы помогаем вам соблюдать требования и оптимизировать налоговую нагрузку.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "Услуги по расчету заработной платы (Payroll)",
        shortText: "Расчет заработной платы не должен быть стрессом.",
        fullText:
          "Мы берем на себя все — от регистрации PAYE до еженедельных или ежемесячных расчетов зарплаты, включая точные расчеты налогов и национального страхования. Мы также подготавливаем расчетные листки, формы P45, P60 и обеспечиваем корректное и своевременное завершение всей годовой отчетности, чтобы ваши сотрудники были довольны, а бизнес соответствовал требованиям.",
        id: "payroll",
      },
      {
        img: images.icon2[6],
        title: "Отчетность CIS",
        shortText:
          "Для подрядчиков в строительстве своевременная и точная отчетность CIS имеет решающее значение.",
        fullText:
          "Мы управляем всеми аспектами соблюдения требований CIS, включая подготовку отчетов по удержаниям и подачу отчетности в HMRC. Это позволяет вам сосредоточиться на выполнении проектов, пока мы обеспечиваем выполнение всех обязательств без ошибок и задержек.",
        id: "company_cis",
      },
      {
        img: images.icon2[7],
        title: "Управленческий учет и отчетность",
        shortText:
          "Контролируйте эффективность бизнеса с помощью регулярной управленческой отчетности.",
        fullText:
          "Мы предоставляем понятные и практичные отчеты, которые помогают отслеживать прибыльность, контролировать денежные потоки и принимать обоснованные решения в течение года, позволяя вам управлять бизнесом проактивно, а не реагировать на проблемы постфактум.",
        id: "manage_accounts",
      },
      {
        img: images.icon2[8],
        title: "Бизнес-прогнозирование и бюджетирование",
        shortText: "Планирование роста требует точных прогнозов и бюджетов.",
        fullText:
          "Мы помогаем создавать подробные финансовые прогнозы и бюджеты, позволяя эффективно управлять денежными потоками, предвидеть будущие вызовы и принимать стратегические решения для устойчивого роста бизнеса.",
        id: "business_forecast",
      },
      {
        img: images.icon2[9],
        title: "Настройка облачной бухгалтерии и обучение",
        shortText:
          "Мы настраиваем облачные бухгалтерские системы, такие как Xero, QuickBooks или Sage, и проводим полное обучение для вас и вашей команды.",
        fullText:
          "Облачная бухгалтерия обеспечивает доступ к финансовым данным в реальном времени, упрощает учет и делает отчетность и соблюдение требований проще, чем когда-либо.",
        id: "cloud_accouunting",
      },
      {
        img: images.icon2[10],
        title: "Поддержка при проверках и запросах HMRC",
        shortText:
          "Столкновение с проверкой или запросом от HMRC может быть пугающим.",
        fullText:
          "Наша команда экспертов представляет ваши интересы, ведет всю переписку и обеспечивает профессиональное сопровождение процесса. Мы защищаем ваши интересы, помогаем прояснить любые вопросы и работаем над достижением наилучшего результата, снижая стресс и влияние на ваш бизнес.",
        id: "hmrc_investigations",
      },
    ],
    pertnership: [
      {
        img: images.icon2[1],
        title: "Регистрация в HMRC",
        shortText:
          "Создание партнёрства требует точной регистрации в HMRC, чтобы ваш бизнес с самого начала соответствовал требованиям и был правильно структурирован.",
        fullText:
          "Мы управляем всем процессом регистрации от вашего имени, обеспечивая выполнение всех юридических и налоговых обязательств, включая регистрацию партнёрства для Self Assessment и корректное внесение данных каждого партнёра. Беря на себя все сложности, мы снижаем риск ошибок, которые могут привести к задержкам или проблемам в будущем. С нашей поддержкой ваше партнёрство получает прочную правовую и финансовую основу, позволяя вам сосредоточиться на развитии бизнеса с уверенностью.",
        id: "register_with_hmrc",
      },
      {
        img: images.icon2[2],
        title: "Налогообложение (Taxation)",
        shortText:
          "Налогообложение партнёрства включает как налоговую декларацию самого партнёрства, так и индивидуальные декларации Self Assessment для каждого партнёра.",
        fullText:
          "Мы берем на себя весь процесс, обеспечивая точность, соответствие требованиям и своевременную подачу отчетности. Наша команда детально анализирует финансовую информацию, применяет соответствующие льготы и обеспечивает корректное распределение прибыли между партнёрами. Такой подход защищает ваше партнёрство от штрафов и одновременно повышает налоговую эффективность как для бизнеса, так и для его участников. Вы можете быть уверены, что ваши налоговые обязательства организованы чётко и профессионально.",
        id: "taxation",
      },
      {
        img: images.icon2[3],
        title: "Cloud Accounting Setup & Training",
        shortText:
          "Мы предоставляем полный цикл настройки облачных бухгалтерских систем, таких как Xero, QuickBooks или FreeAgent, обеспечивая упорядоченность и удобство управления финансовыми данными партнёрства.",
        fullText:
          " Наша команда настраивает программное обеспечение под нужды вашего бизнеса, помогая оптимизировать ежедневный учет и отчетность. Мы также проводим комплексное обучение для партнёров и персонала, чтобы вы могли уверенно пользоваться системой. Благодаря понятным инструкциям и постоянной поддержке ваше партнёрство получает доступ к финансовой информации в реальном времени, повышает эффективность и полностью соответствует требованиям цифрового учета.",
        id: "cloud_accounting",
      },
      {
        img: images.icon2[4],
        title: "Декларация по налогу на прибыль (CT600)",
        shortText:
          "Ориентироваться в корпоративном налогообложении может быть сложно, но мы упрощаем этот процесс.",
        fullText:
          "Мы берем на себя подачу формы CT600 от начала до конца, выявляя допустимые расходы, применяя соответствующие льготы и гарантируя, что вы платите только то, что положено по закону. Благодаря тщательному планированию мы помогаем вам соблюдать требования и оптимизировать налоговую нагрузку.",
        id: "company_tax",
      },
      {
        img: images.icon2[5],
        title: "HMRC Investigations & Enquiries Support",
        shortText:
          "If your partnership is selected for an HMRC enquiry, we provide full professional support from start to finish. Our team manages all communication with HMRC on your behalf, ensuring accurate information is provided promptly.",
        fullText:
          "We guide you through documentation requirements, clarify the scope of the enquiry, and work to resolve matters fairly and efficiently. With our expertise, you can minimise disruption to your business, reduce stress, and ensure the best possible outcome. Our aim is to protect your partnership while maintaining full compliance with HMRC regulations.",
        id: "hmrc_investigations",
      },
    ],
  },
};
